// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1eroJ","resendInfoText":"OnGoingPaymentBox_resendInfoText__24Jjh"};